import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("jwttoken") || null,
  isAuthenticated: !!localStorage.getItem("jwttoken"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("jwttoken", action.payload);
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("jwttoken");
      localStorage.removeItem("userid");
      localStorage.removeItem("usertype");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
